<template>
    <v-dialog v-model="showDialog" persistent max-width="80%">
        <v-card>
            <v-card-title>
                <div>
                    <h2 v-show="id" class="headline"> Tarefa #{{id}}</h2>
                    <h2 v-show="!id" class="headline"> Nova Tarefa</h2>
                </div>
                <v-spacer></v-spacer>
                <v-btn fab small text @click="doHideDialog">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-card-title>
            <v-progress-linear
              indeterminate
              v-show="isLoading"
              color="green"
            ></v-progress-linear>
            <v-layout column>
                <!-- <v-card> -->
                    <!-- <v-container> -->
                        <v-layout :column="isSmallScreen">
                            <v-flex xs12 align-end flexbox>
                                <v-form class="pl-5 pr-5" ref="form" v-model="valid" lazy-validation>
                                    <v-layout class="pl-4" row wrap>
                                        <v-text-field
                                            v-model="formData.titulo"
                                            :readonly="!formAllowEdit"
                                            label="Titulo"
                                        ></v-text-field>
                                        <v-col
                                            cols="4"
                                            class="pb-0 pt-0"
                                        >
                                            <v-flex>
                                                <v-autocomplete
                                                    v-model="auxProjetoId"
                                                    :readonly="!formAllowEdit"
                                                    :items="storeProjetos.data"
                                                    hide-selected
                                                    item-text="nome"
                                                    item-value="id"
                                                    label="Projeto"
                                                    persistent-hint
                                                >
                                                </v-autocomplete>

                                            </v-flex>
                                        </v-col>
                                    </v-layout>
                                    <tiptap-vuetify
                                      v-model="formData.descricao"
                                      :card-props="{ height: 350 }"
                                      :toolbar-attributes="{ color: '#C8E6C9' }"
                                      label="Descrição"
                                      :extensions="extensions"
                                    />
                                    <v-layout class="pl-4 pr-4" row wrap>
                                        <v-col
                                            cols="3"
                                            class="pl-0 pb-0 pt-0"
                                        >
                                            <v-menu
                                                ref="menuPrazoData"
                                                v-model="menuPrazoData"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                :disabled="!formAllowEdit"
                                                offset-y
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-model="strPrazoData"
                                                        label="Prazo"
                                                        v-on="on"
                                                        v-mask="'##/##/####'"
                                                        :readonly="!formAllowEdit"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="prazoData" locale="pt-br" no-title @input="menuPrazoData = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            class="pl-0 pb-0 pt-0"
                                        >
                                            <v-text-field
                                                type="number"
                                                :readonly="!formAllowEdit"
                                                v-model="formData.horasEstimadas"
                                                label="Horas Estimadas"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            class="pl-0 pb-0 pt-0"
                                        >
                                            <v-text-field
                                                class="pl-2"
                                                type="number"
                                                :readonly="!formAllowEdit"
                                                v-model="formData.horasRealizadas"
                                                label="Horas Realizadas"
                                            ></v-text-field>
                                        </v-col>
                                        <v-spacer></v-spacer>
                                        <v-switch
                                            v-model="formData.concluida"
                                            color="success"
                                            :readonly="!formAllowEdit"
                                            label="Concluída"
                                        ></v-switch>
                                    </v-layout>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    <!-- </v-container> -->
                <!-- </v-card> -->
            </v-layout>
            <v-card-title class="pb-5">
                <v-btn text color="green" v-if="!formAllowEdit" @click="formAllowEdit = !formAllowEdit">
                    <v-icon left>edit</v-icon>Habilitar edição
                </v-btn>
                <v-btn
                    color="success"
                    v-if="formAllowEdit"
                    :disabled="!valid || isLoading"
                    @click="submit"
                >
                    Salvar
                </v-btn>
                <v-spacer></v-spacer>
                <v-menu open-on-click bottom offset-y v-if="!formAllowEdit">
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on">
                            <v-icon >more_vert</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item @click="doRemove(recordId)">
                            <v-list-item-action>
                                <v-icon>delete</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Remover</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
        </v-card>
    </v-dialog>
</template>

<style>
.inputPrice input[type='number'] {
    -moz-appearance:textfield;
}
.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>

<script>

import Utils from '@/utils/Utils.js';
import { EventBus } from '@/EventBus.js';
import { Store } from '@/utils/Store.js';
import moment from 'moment';
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'

export default {
    components: { TiptapVuetify },
    props: ['id', 'cliente', 'showDialog'],
    computed: {
        isSmallScreen() {
            return this.$vuetify.breakpoint.smAndDown;
        }
    },
    data: () => ({
        storeProjetos: new Store({
            url: '/projetos/Projetos'
        }),
        recordId: null,
        auxProjetoId: null,
        isLoading: false,
        formAllowEdit: false,
        formData: {
            concluida: false
        },
        menuPrazoData: false,
        prazoData: "",
        strDataCadastro: "",
        strPrazoData: "",
        strPrazoHorario: "",
        strConcluida: false,
        valid: true,
        extensions: [
            History,
            Blockquote,
            Link,
            Underline,
            Strike,
            Italic,
            ListItem,
            BulletList,
            OrderedList,
            [Heading, { options: { levels: [1, 2, 3] } }],
            Bold,
            Code,
            HorizontalRule,
            Paragraph,
            HardBreak
        ]
    }),
    methods: {
        doHideDialog() {
            // const objAudio = new Audio('static/mano-lima-1.mp3');
            // const objAudio = new Audio('static/fundo-grota-1.mp3');
            // objAudio.play();
            EventBus.$emit('hideTarefaDetalhes');
            this.recordId = null;
            this.auxProjetoId = null;
            this.isLoading = false;
            this.formAllowEdit = false;
            this.formData = { concluida: false };
            this.prazoData = "";
            this.strPrazoData = "";
        },
        loadData() {
            this.formAllowEdit = false;
            this.recordId = this.id;
            const self = this;
            this.isLoading = true;
            Utils.apiAjax({
                url: '/tarefas/Tarefas/' + this.recordId,
                success: (response, rawResponse) => {
                    self.isLoading = false;
                    const auxData = response.data[0];

                    self.formData = auxData;

                    if (auxData.projeto) {
                        self.auxProjetoId = auxData.projeto.id;
                    }

                    self.strConcluida = (auxData.concluida) ? 'Sim' : 'Não';

                    self.strDataCadastro = moment(auxData.dataCadastro).format('DD/MM/YYYY HH:mm');
                    self.strPrazoData = '';
                    if (auxData.data) {
                        self.strPrazoData = moment(auxData.data).format('DD/MM/YYYY');
                    }
                    // self.strPrazoHorario = '';
                    // let auxHorario = moment(auxData.dataPrazo).format('HH:mm');
                    // if (auxHorario !== '00:00') {
                    //     self.strPrazoHorario = auxHorario;
                    // }
                },
                failure: (response, rawResponse) => {
                    self.isLoading = false;
                    return true;
                }
            });
        },
        doRemove(id) {
            const self = this;
            EventBus.$emit('showConfirmDialog', {
                title: 'Atenção',
                text: 'Deseja apagar a tarefa?',
                action: () => {
                    self.isLoading = true;
                    Utils.apiAjax({
                        url: '/tarefas/Tarefas/' + id,
                        method: 'delete',
                        success: (response, rawResponse) => {
                            self.isLoading = false;
                            EventBus.$emit('showPopUp', {
                                text: 'Tarefa removida com sucesso'
                            });
                            EventBus.$emit('tarefaRemovida', {
                                id: id
                            });
                            self.doHideDialog();
                        },
                        failure: (response, rawResponse) => {
                            self.isLoading = false;
                            const errorMsg = (response.msg !== '' && response.msg !== undefined) ? response.msg : 'Erro ao remover registro';
                            EventBus.$emit('showErrorDialog', errorMsg);
                            return true;
                        }
                    });
                }
            });
        },
        submit() {
            let self = this;
            this.isLoading = true;

            let params = this.formData;

            delete params.data;
            if (this.strPrazoData) {
                params.data = moment(this.strPrazoData, 'DD/MM/YYYY').endOf('day').format();
            }

            delete params.cliente;
            if (this.cliente) {
                params.cliente = this.cliente;
            }

            delete params.projeto;
            if (this.auxProjetoId) {
                params.projeto = this.auxProjetoId;
            }

            if (this.recordId) {
                let id = this.recordId;

                Utils.apiAjax({
                    url: '/tarefas/Tarefas/' + id,
                    method: 'put',
                    params,
                    success: () => {
                        EventBus.$emit('tarefaAlterada', {
                            id: id
                        });
                        EventBus.$emit('showPopUp', {
                            text: 'Tarefa alterada com sucesso'
                        });
                        self.doHideDialog();
                    },
                    failure: () => {
                        self.isLoading = false;
                        EventBus.$emit('showErrorDialog', 'Erro ao atualizar registro');
                        return true;
                    }
                });
            } else {
                Utils.apiAjax({
                    url: '/tarefas/Tarefas',
                    method: 'post',
                    params,
                    success: () => {
                        EventBus.$emit('tarefaInserida');
                        EventBus.$emit('showPopUp', {
                            text: 'Tarefa cadastrada com sucesso'
                        });
                        self.doHideDialog();
                    },
                    failure: () => {
                        self.isLoading = false;
                        EventBus.$emit('showErrorDialog', 'Erro ao inserir registro');
                        return true;
                    }
                });
            }
        }
    },
    watch: {
        'prazoData': function (val) {
            if (this.prazoData !== '' && this.prazoData !== undefined) {
                this.strPrazoData = moment(this.prazoData, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }
        },
        'showDialog': function (val) {
            if (!this.id) {
                this.formAllowEdit = true;
            }
            if (this.showDialog) {
                this.storeProjetos.load({
                    params: {
                        cliente: this.cliente
                    }
                });
            }
            if (this.showDialog && this.id) {
                this.loadData();
            }
        }
    }
}
</script>